import { z } from 'zod';

export const NoteSchema = z.object({
  id: z.string(),
  text: z.string(),
  timestamp: z.number(),
  author: z.string().optional()
});

export const TaskSchema = z.object({
  id: z.union([z.string(), z.number()]),
  globalId: z.string().optional(),
  name: z.string().max(500, 'Name ist zu lang').optional().or(z.string().length(0)),
  description: z.string().optional(),
  start: z.string().optional().or(z.string().length(0)),
  end: z.string().optional().or(z.string().length(0)),
  startTime: z.string().optional(),
  endTime: z.string().optional(),
  subtitle: z.string().optional(),
  notes: z.union([z.string(), z.array(NoteSchema)]).optional(),
  type: z.enum([
    'task', 'milestone', 'meeting', 'decision', 'deadline', 'approval', 
    'workshop', 'iteration', 'review', 'cooperation', 'contact', 
    'folder', 'topic', 'idea'
  ]).optional(),
  completed: z.boolean().optional(),
  status: z.string().optional(),
  assignee: z.string().optional(),
  isInlineNew: z.boolean().optional(),
  projectId: z.string(),
  parentId: z.union([z.string(), z.number()]).optional(),
  priority: z.enum(['none', 'low', 'medium', 'high']).optional(),
  isExpanded: z.boolean().optional(),
  isCollapsed: z.boolean().optional(),
  dependencies: z.array(z.union([z.string(), z.number()])).optional(),
  color: z.string().optional(),
  category: z.string().optional(),
  organization: z.string().optional(),
  contactEmail: z.string().optional(),
  contactPhone: z.string().optional(),
  lastContactDate: z.string().optional(),
  role: z.string().optional(),
  goals: z.string().optional(),
  socialCapital: z.number().optional(),
  mood: z.string().optional(),
  contactFunction: z.string().optional(),
  sortOrder: z.number().optional(),
  contactChecklist: z.array(z.object({
    id: z.string(),
    text: z.string(),
    completed: z.boolean()
  })).optional(),
  checklist: z.array(z.object({
    id: z.string(),
    text: z.string(),
    completed: z.boolean()
  })).optional(),
  _depth: z.number().optional(),
  _hasChildren: z.boolean().optional(),
  _childCount: z.number().optional(),
  x: z.number().optional(),
  y: z.number().optional(),
  projectName: z.string().optional(),
  workspace: z.enum(['professional', 'private']).optional(),
  history: z.array(z.object({
    id: z.string(),
    timestamp: z.number(),
    user: z.string(),
    field: z.string(),
    oldValue: z.any().optional(),
    newValue: z.any().optional(),
    message: z.string()
  })).optional(),
  archived: z.boolean().optional(),
  tenantId: z.string().optional(),
  createdAt: z.number().optional(),
  updatedAt: z.number().optional()
}).passthrough();

export const ProjectSchema = z.object({
  id: z.string(),
  name: z.string().min(1, 'Name darf nicht leer sein').max(200, 'Name ist zu lang'),
  lastModified: z.number(),
  archived: z.boolean().optional(),
  color: z.string().optional(),
  workspace: z.enum(['professional', 'private']).optional(),
  userId: z.string(),
  order: z.number().optional(),
  categoryId: z.string().optional(),
  metadata: z.any().optional(),
  changelog: z.any().optional(),
  tenantId: z.string().optional()
}).passthrough();
